module.exports = "https://web-assets.ifttt.com/packs/media/location_field/location_exit-3ebb2dab.svg";